import React, { Component } from 'react';

import './user-select.css';

const JsonTable = require ('ts-react-json-table');

export default class UserSelect extends Component {
    constructor(props) {
        super(props);
        this.state = { row: false, sort: false};
    }

    render() {
        var self = this,
            items = this.props.users.slice();

        if( this.state.sort ){
          items.sort( function( a, b ){
             return a[ self.state.sort ] > b[ self.state.sort ] ? 1 : -1;
          });
        }

        let columns = [
            { label: 'User ID', key: 'id' },
            { label: 'Nachname', key: 'last_name' },
            { label: 'Vorname', key: 'first_name' },
            { label: 'Email', key: 'email' },
            { label: 'Nutzername', key: 'user_name' },
            { label: 'Rolle', key: 'role' }
        ];

        return <div className="wrapper">
         <JsonTable
          caption={ this.props.caption }
          rows={ items }
          columns={ columns }
          settings={ this.getSettings() }
          onClickHeader={ this.onClickHeader }
          onClickRow={ this.onClickRow } />
        </div>;
    }

    getSettings() {
      var self = this;

      return {
        keyField: 'id',
        headerClass: function( current, key ){
            if( self.state.sort === key )
              return current + ' headerSelected';
            return current;
        },
        rowClass: function( current, item ){
          if( self.state.row === item.id )
            return current + ' rowSelected';
          return current;
        }
      }
    }

    onClickHeader = ( e, column ) => {
        this.setState( {sort: column} );
    }

    onClickRow = ( e, item ) => {
        this.setState( {row: item.id} );
    }
}



// WEBPACK FOOTER //
// ./src/user-select.js